import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const InfoCard = ({
  children, classes, staticContext, title, ...other
}) => (
  <Card {...other}>
    <CardContent>
      <Typography variant="h5" component="h2">
        { title }
      </Typography>
      { children }
    </CardContent>
  </Card>
);

const styles = () => ({

});

InfoCard.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  classes: PropTypes.object.isRequired,
  staticContext: PropTypes.any,
};

InfoCard.defaultProps = {
  children: undefined,
  title: undefined,
  staticContext: undefined,
};

export default withRouter(withStyles(styles)(InfoCard));
